
export default {
  namespaced: true,
  state: {
    previewRefresherKey: 0,
    defaultPreviewKey: 0,
    collectionId: null,
    slideIdBeingEdited: null,
  },
  actions: {
    async SET_COLLECTION_ID({ commit }, collectionId) {
      commit('SET_COLLECTION_ID', collectionId);
    },
    async SET_SLIDE_ID_BEING_EDITED({ commit }, slideIdBeingEdited) {
      commit('SET_SLIDE_ID_BEING_EDITED', slideIdBeingEdited);
      commit('INCREMENT_PREVIEW_KEY');
    },
    async INCREMENT_PREVIEW_KEY({ commit }) {
      commit('INCREMENT_PREVIEW_KEY');
    },
    async INCREMENT_DEFAULT_PREVIEW_KEY({ commit }) {
      commit('INCREMENT_DEFAULT_PREVIEW_KEY');
    },
  },
  getters: {
    collectionId: state => state.collectionId,
    slideIdBeingEdited: state => state.slideIdBeingEdited,
    previewRefresherKey: state => state.previewRefresherKey,
    defaultPreviewKey: state => state.defaultPreviewKey,
  },
  mutations: {
    SET_COLLECTION_ID: (state, collectionId) => {
      state.collectionId = collectionId;
    },
    SET_SLIDE_ID_BEING_EDITED: (state, slideIdBeingEdited) => {
      state.slideIdBeingEdited = slideIdBeingEdited;
    },
    INCREMENT_PREVIEW_KEY: (state) => {
      state.previewRefresherKey += 1;
    },
    INCREMENT_DEFAULT_PREVIEW_KEY: (state) => {
      state.defaultPreviewKey += 1;
    },
  },
};
